'use strict';

import cf7Helpers from '../../../src/js/shared/cf7Helpers';
import renderMap from '../../../src/js/site/map/renderMap';
import helper from '../../../src/js/site/helper';

const $ = jQuery.noConflict();

$(function() {

	const contactUs = {
		init: function() {
			cf7Helpers.afterFormSubmit();
			cf7Helpers.bindEvents();
		},
	};

	contactUs.init();
});

const Map = {

	apiKey: '',
	locations: [],

	init: ()=> {
		Map.initDom();
		helper.addScript(
			'https://maps.googleapis.com/maps/api/js?key=' + Map.apiKey,
			true,
			Map.lateInit
		);
	},

	initDom: () => {
		Map.apiKey = window.fwsApiKey;
		Map.locations = window.fwsLocations;
	},

	lateInit: ()=>{
		renderMap.init(Map.locations);
	}

};

window.addEventListener('load', () => {

	setTimeout(() => {
		Map.init();
	}, 0);

	setTimeout(() => {
		document.querySelector('#map').classList.add('active');
	}, 2700);
});